import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import "./style.scss";

const Navigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const links = [
    { path: "/", label: "Projets" },
    { path: "/informations", label: "Informations" },
    { path: "/indexgraphique", label: "Index graphique" },
  ];

  const sortedLinks = [
    ...links.filter((link) => link.path === currentPath),
    ...links.filter((link) => link.path !== currentPath),
  ];

  return (
    <nav>
      <ul>
        {sortedLinks.map((link, index) => (
          <li
            key={index}
            className={link.path === currentPath ? "active-link" : ""}
          >
            <NavLink
              to={link.path}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
